import { render } from "./NavBarVSS.vue?vue&type=template&id=e98dea30&scoped=true"
import script from "./NavBarVSS.vue?vue&type=script&lang=js"
export * from "./NavBarVSS.vue?vue&type=script&lang=js"

import "./NavBarVSS.vue?vue&type=style&index=0&id=e98dea30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98dea30"]])

export default __exports__